import { createElement, PropsWithChildren } from "react";
import csv from "./translations.csv";

const txs = csv.find(
  (a) =>
    a["lang"] === navigator.language ||
    a["lang"] === navigator.language.split("-")[0]
) || { lang: navigator.language };

const warnedKeys = new Set<string>();

/**
 * @deprecated Use `useTranslation` hook from rujira.ui instead.
 * This function will be removed in a future version.
 *
 * @example
 * // Before (deprecated):
 * import { i18n } from "rujira.ui";
 * i18n.t("Hello World")
 *
 * // After:
 * import { useTranslation } from "rujira.ui";
 * const { t } = useTranslation();
 * t("greeting.hello")
 */
export const t = (string: string) => {
  if (process.env.NODE_ENV === "development" && !warnedKeys.has(string)) {
    warnedKeys.add(string);
    console.warn(
      `[i18n] Deprecated: i18n.t("${string}") - Use useTranslation hook instead`
    );
  }

  const trans = txs[string];
  if (!trans) {
    txs[string] = "";

    const current = JSON.parse(localStorage.getItem("i18n") || "{}");
    localStorage.setItem(
      "i18n",
      JSON.stringify({ ...current, [txs["lang"]]: txs })
    );
  }
  return trans || string;
};

/**
 * @deprecated Use standard HTML elements with useTranslation hook instead.
 * These component wrappers will be removed in a future version.
 *
 * @example
 * // Before (deprecated):
 * <i18n.span>Hello</i18n.span>
 *
 * // After:
 * const { t } = useTranslation();
 * <span>{t("greeting.hello")}</span>
 */
const comp =
  (tag: string): React.FC<PropsWithChildren<{}>> =>
  (props) =>
    createElement(
      tag,
      props,
      typeof props.children === "string" ? t(props.children) : props.children
    );

/** @deprecated Use standard `<a>` with useTranslation hook */
export const a: React.FC<JSX.IntrinsicElements["a"]> = comp("a");
export const strong: React.FC<JSX.IntrinsicElements["strong"]> = comp("strong");
export const label: React.FC<JSX.IntrinsicElements["label"]> = comp("label");
export const li: React.FC<JSX.IntrinsicElements["li"]> = comp("li");
export const h1: React.FC<JSX.IntrinsicElements["h1"]> = comp("h1");
export const h2: React.FC<JSX.IntrinsicElements["h2"]> = comp("h2");
export const h3: React.FC<JSX.IntrinsicElements["h3"]> = comp("h3");
export const h4: React.FC<JSX.IntrinsicElements["h4"]> = comp("h4");
export const th: React.FC<JSX.IntrinsicElements["th"]> = comp("th");
export const td: React.FC<JSX.IntrinsicElements["td"]> = comp("td");
export const div: React.FC<JSX.IntrinsicElements["div"]> = comp("div");
export const span: React.FC<JSX.IntrinsicElements["span"]> = comp("span");
export const small: React.FC<JSX.IntrinsicElements["small"]> = comp("small");
export const p: React.FC<JSX.IntrinsicElements["p"]> = comp("p");
export const button: React.FC<JSX.IntrinsicElements["button"]> = comp("button");
export const option: React.FC<JSX.IntrinsicElements["option"]> = comp("option");
